import type { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './useFinder.translations'
import type { FinderConfig } from './useFinder.types'

type I18n = ReturnType<typeof useI18n>
type Translate = (...params: Parameters<I18n>) => string

export const MACBOOK_SCREEN_SIZES = ['13', '14', '15', '16'] as const

const screenSizeValues = MACBOOK_SCREEN_SIZES.map((size) => `${size}"`)

export function getMacbookFinderConfig(i18n: Translate): FinderConfig {
  return {
    id: 'apple-macbook',
    criteria: [
      {
        kind: 'usages',
        facetName: 'usages.label',
        title: i18n(translations.usageTitle),
        tooltip: i18n(translations.usageTooltip),
      },
      {
        kind: 'budget',
        facetName: 'price',
        title: i18n(translations.budgetTitle),
        presets: [
          { id: 'budget-300', maxValue: 300 },
          { id: 'budget-450', maxValue: 450 },
          { id: 'budget-600', maxValue: 600 },
          { id: 'budget-750', maxValue: 750 },
          { id: 'budget-900', maxValue: 900 },
          { id: 'budget-1050', maxValue: 1050 },
        ],
      },
      {
        kind: 'screensize',
        facetName: 'screen_size',
        title: i18n(translations.sizeTitle),
        rangeMin: 11,
        rangeMax: 16,
        values: screenSizeValues,
      },
      {
        kind: 'conditions',
        facetName: 'backbox_grade',
        title: i18n(translations.conditionTitle),
        tooltip: i18n(translations.conditionTooltip),
      },
      {
        kind: 'requirements',
        title: i18n(translations.requirementsTitle),
        moreFiltersLabel: i18n(translations.moreFiltersLabel),
      },
    ],
  }
}
